// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"727":"66d46012","927":"7d7dcff5"}[chunkId] + ".css";
};